module.exports = require('../build/addons/MomentLocaleUtils');



//////////////////
// WEBPACK FOOTER
// ./~/react-day-picker/moment/index.js
// module id = 166
// module chunks = 168707334958949